import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';
import LoadingPage from '../pages/LoadingPage';

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_ANON_KEY!
);

interface PublicRouteProps {
  darkMode: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ darkMode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      const session = await supabase.auth.getSession();
      setIsAuthenticated(!!session.data.session);
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <LoadingPage darkMode={darkMode} />;
  }

  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoute;